import { render, staticRenderFns } from "./Ended.vue?vue&type=template&id=49038f3e&"
import script from "./Ended.vue?vue&type=script&lang=js&"
export * from "./Ended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports